<template>
  <a-modal
    :title="$t('change.password')"
    v-model="visible"
    @cancel="handleCancel"
    :destroyOnClose="true"
    :footer="null"
    :centered="true"
    :width="395"
  >
    <p class="error">{{ error }}</p>
    <a-form :form="form" class="form" @submit.prevent="handleSave">
      <a-form-item class="current-password-input">
        <a-input-password v-model="currentPassword" :placeholder="$t('current.password')" />
      </a-form-item>
      <create-password-input v-model="newPassword" class="create-password-input" />
      <a-button :loading="loading" :disabled="disabled" type="primary" html-type="submit">
        {{ $t('save') }}
      </a-button>
    </a-form>
  </a-modal>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions } from 'vuex';
import CreatePasswordInput from '@/components/common/CreatePasswordInput.vue';
import { CHANGE_PASSWORD } from '@/store/session/actionTypes';

export default {
  components: {
    CreatePasswordInput,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      loading: false,
      disabled: true,
      error: '',
    };
  },
  methods: {
    ...mapActions({
      changePassword: CHANGE_PASSWORD,
    }),
    handleCancel() {
      this.error = '';
      this.currentPassword = '';
      this.disabled = true;
      this.$emit('cancel');
    },
    async handleSave() {
      this.loading = true;

      try {
        await this.reauthenticate();
        await this.changePassword(this.newPassword);
        this.handleCancel();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    reauthenticate() {
      const user = firebase.auth().currentUser;
      const cred = firebase.auth.EmailAuthProvider.credential(user.email, this.currentPassword);
      return user.reauthenticateWithCredential(cred);
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'changePassword' });
  },
  provide() {
    return {
      form: this.form,
    };
  },
  watch: {
    newPassword() {
      this.form.validateFieldsAndScroll((err) => {
        if (!err) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
.error {
  text-align: center;
  color: $red;
}
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.current-password-input {
  width: 100%;
}
</style>
<style lang="scss">
@import '~@/assets/styles/colors';
@import '~@/assets/styles/fonts';

.create-password-input {
  .password-inputs {
    display: flex;
    flex-direction: column;
  }
  .password-rules {
    text-align: center;
  }
}
</style>
